export const WISHLIST_UPDATE_EVENT_NAME = "ofc:wishlist.item.updated";

export function subscribeToWishlistUpdateEvent(eventHandler: () => void): () => void {
    const listener = () => {
        eventHandler();
    };
    window.document.addEventListener(WISHLIST_UPDATE_EVENT_NAME, listener);

    return () => window.document.removeEventListener(WISHLIST_UPDATE_EVENT_NAME, listener);
}

export function dispatchWishlistUpdateEvent(): void {
    window.document.dispatchEvent(new CustomEvent(WISHLIST_UPDATE_EVENT_NAME));
}
